import {useForm} from "@mantine/form";
import {
    FormLocationInformationFormValues,
    formLocationInformationInitialValues
} from "./Form.location.information.types";
import {Button, Divider, Grid, Group, Select, Stack, Title} from "@mantine/core";
import {ArrowRight} from "tabler-icons-react";
import React from "react";
import {IEntity, IUser} from "../../../../api/User/User.types";

interface Props {
    onSubmit?: (values: any) => void
    buttons?: any,
    initialValues?: any,
    shipper?:IEntity,
    consignee?:IEntity,
    user:IUser,
}

function LocationInformation({onSubmit, buttons, initialValues, user, shipper, consignee}: Props) {

    const form = useForm({
        initialValues: initialValues || formLocationInformationInitialValues
    });

    function handleSubmit(values: any) {
        if (onSubmit) {
            form.validate()
            onSubmit(values)
        }
    }

    function renderButtons() {
        if (buttons) {
            return buttons;
        } else {
            return (
                <Group position="right" mt="xl" align="flex-end">
                    <Button color="blue" type="submit" rightIcon={<ArrowRight/>}>
                        Next
                    </Button>
                </Group>
            )
        }
    }

    if (!shipper || !consignee){
        return (
            <div>
                You must choose a Shipper and a Consignee before you can choose a Location.
            </div>
        )
    }

    function getCurShipperFromUser(){
        return user?.shippers?.find(sh => sh.entityID === shipper!.entityID);
    }
    function getCurConsigneeFromUser(){
        return user?.consignees?.find(con => con.entityID === consignee!.entityID);
    }

    function getShipperLocations(){
        let curShipper = getCurShipperFromUser();
        return curShipper ? curShipper.locations : [];
    }

    function getConsigneeLocations(){
        let curConsignee = getCurConsigneeFromUser();
        return curConsignee ? curConsignee.locations : [];
    }

    getShipperLocations();

    return (
        <form onSubmit={form.onSubmit(handleSubmit)}>
            <Stack>
                <Title order={3}>Location Information</Title>
                <Divider/>
                <Grid>
                    <Grid.Col md={12}>
                        <Select
                            data={getShipperLocations()}
                            description={`From ${getCurShipperFromUser()?.entityName}` || "N/A"}
                            required
                            placeholder="Origin"
                            label="Origin"
                            {...form.getInputProps(FormLocationInformationFormValues.origin)}
                        />
                    </Grid.Col>
                    <Grid.Col md={12}>
                        <Select
                            data={getShipperLocations()}
                            description={`From ${getCurShipperFromUser()?.entityName}`  || "N/A"}
                            required
                            placeholder="Loading Port"
                            label="Loading Port (POL)"
                            {...form.getInputProps(FormLocationInformationFormValues.loadingPort)}
                        />
                    </Grid.Col>
                    <Grid.Col md={12}>
                        <Select
                            data={getConsigneeLocations()}
                            description={`From ${getCurConsigneeFromUser()?.entityName || "N/A"}`}
                            required
                            placeholder="Destination"
                            label="Destination"
                            {...form.getInputProps(FormLocationInformationFormValues.destination)}
                        />
                    </Grid.Col>
                </Grid>
                {renderButtons()}
            </Stack>
        </form>
    )

}

export default LocationInformation;